// Exact plan names/descriptions extracted from the existing locale dictionaries.
// Catalog parity tests keep these bounded Edge labels synchronized.
import type { Lang } from "../../../src/i18n/locale.ts";
import type { FitnessCuratedPlanCatalogId } from "./fitnessCuratedPlans.ts";
export const FITNESS_CURATED_PLAN_LABELS: Record<Lang, Record<FitnessCuratedPlanCatalogId, { name: string; description: string }>> = {
  "EN": {
    "beginner_weight_loss": {
      "name": "Fat Burn Starter",
      "description": "3x/week full body circuit for weight loss. High reps, short rest."
    },
    "beginner_hypertrophy": {
      "name": "Muscle Builder",
      "description": "4x/week push/pull/legs split. Build a solid foundation."
    },
    "intermediate_strength": {
      "name": "Strength Foundation",
      "description": "4x/week upper/lower split. Heavy compound lifts for strength."
    },
    "intermediate_hypertrophy": {
      "name": "Volume Machine",
      "description": "5x/week PPL + upper/lower. High volume for maximum growth."
    },
    "advanced_strength": {
      "name": "Powerhouse",
      "description": "5x/week powerlifting base. Squat, bench, deadlift focused."
    },
    "advanced_performance": {
      "name": "Athlete Elite",
      "description": "6x/week athletic training. Power, hypertrophy, and conditioning."
    }
  },
  "PT-BR": {
    "beginner_weight_loss": {
      "name": "Queima Inicial",
      "description": "3x/semana circuito corpo inteiro para perda de peso. Reps altas, descanso curto."
    },
    "beginner_hypertrophy": {
      "name": "Construtor Muscular",
      "description": "4x/semana push/pull/pernas. Construa uma base sólida."
    },
    "intermediate_strength": {
      "name": "Base de Força",
      "description": "4x/semana superior/inferior. Exercícios compostos pesados para força."
    },
    "intermediate_hypertrophy": {
      "name": "Máquina de Volume",
      "description": "5x/semana PPL + superior/inferior. Alto volume para crescimento máximo."
    },
    "advanced_strength": {
      "name": "Força Total",
      "description": "5x/semana base powerlifting. Foco em squat, bench, deadlift."
    },
    "advanced_performance": {
      "name": "Atleta Elite",
      "description": "6x/semana treino atlético. Potência, hipertrofia e condicionamento."
    }
  },
  "NL": {
    "beginner_weight_loss": {
      "name": "Vetverbranding Start",
      "description": "3x/week full body circuit voor gewichtsverlies. Hoge herhalingen, kort rust."
    },
    "beginner_hypertrophy": {
      "name": "Spieropbouw",
      "description": "4x/week push/pull/benen split. Bouw een solide basis."
    },
    "intermediate_strength": {
      "name": "Kracht Fundament",
      "description": "4x/week boven/onder split. Zware samengestelde oefeningen."
    },
    "intermediate_hypertrophy": {
      "name": "Volume Machine",
      "description": "5x/week PPL + boven/onder. Hoog volume voor maximale groei."
    },
    "advanced_strength": {
      "name": "Krachtcentrale",
      "description": "5x/week powerlifting basis. Squat, bench, deadlift gericht."
    },
    "advanced_performance": {
      "name": "Atleet Elite",
      "description": "6x/week atletische training. Kracht, hypertrofie en conditie."
    }
  },
  "ES": {
    "beginner_weight_loss": {
      "name": "Quema Inicial",
      "description": "3x/semana circuito de cuerpo completo para perder peso. Reps altas, descanso corto."
    },
    "beginner_hypertrophy": {
      "name": "Constructor Muscular",
      "description": "4x/semana empuje/tirón/pierna. Construye una base sólida."
    },
    "intermediate_strength": {
      "name": "Base de Fuerza",
      "description": "4x/semana torso/pierna. Compuestos pesados para ganar fuerza."
    },
    "intermediate_hypertrophy": {
      "name": "Máquina de Volumen",
      "description": "5x/semana PPL + torso/pierna. Alto volumen para crecimiento máximo."
    },
    "advanced_strength": {
      "name": "Fuerza Total",
      "description": "5x/semana base de powerlifting. Foco en squat, bench y deadlift."
    },
    "advanced_performance": {
      "name": "Atleta Élite",
      "description": "6x/semana entrenamiento atlético. Potencia, hipertrofia y acondicionamiento."
    }
  },
  "FR": {
    "beginner_weight_loss": {
      "name": "Brûle-graisse débutant",
      "description": "Circuit corps entier 3x/semaine pour perdre du poids. Beaucoup de répétitions, repos court."
    },
    "beginner_hypertrophy": {
      "name": "Bâtisseur musculaire",
      "description": "Push/pull/jambes 4x/semaine. Construis une base solide."
    },
    "intermediate_strength": {
      "name": "Base de force",
      "description": "Haut/bas du corps 4x/semaine. Exercices polyarticulaires lourds pour gagner en force."
    },
    "intermediate_hypertrophy": {
      "name": "Machine à volume",
      "description": "PPL + haut/bas du corps 5x/semaine. Volume élevé pour une croissance maximale."
    },
    "advanced_strength": {
      "name": "Force totale",
      "description": "Base de powerlifting 5x/semaine. Squat, développé couché et soulevé de terre."
    },
    "advanced_performance": {
      "name": "Athlète d'élite",
      "description": "Entraînement athlétique 6x/semaine. Puissance, hypertrophie et conditionnement."
    }
  },
  "IT": {
    "beginner_weight_loss": {
      "name": "Brucia grassi iniziale",
      "description": "Circuito total body 3 volte a settimana per perdere peso. Ripetizioni alte, recupero breve."
    },
    "beginner_hypertrophy": {
      "name": "Costruttore muscolare",
      "description": "Push/pull/gambe 4 volte a settimana. Costruisci una base solida."
    },
    "intermediate_strength": {
      "name": "Base di forza",
      "description": "Parte superiore/inferiore 4 volte a settimana. Esercizi multiarticolari pesanti per la forza."
    },
    "intermediate_hypertrophy": {
      "name": "Macchina da volume",
      "description": "PPL + parte superiore/inferiore 5 volte a settimana. Alto volume per la massima crescita."
    },
    "advanced_strength": {
      "name": "Forza totale",
      "description": "Base di powerlifting 5 volte a settimana. Concentrazione su squat, panca e stacco."
    },
    "advanced_performance": {
      "name": "Atleta d'élite",
      "description": "Allenamento atletico 6 volte a settimana. Potenza, ipertrofia e condizionamento."
    }
  },
  "DE": {
    "beginner_weight_loss": {
      "name": "Fettverbrennungsstart",
      "description": "3x/Woche Ganzkörper-Zirkel zum Abnehmen. Viele Wiederholungen, kurze Pausen."
    },
    "beginner_hypertrophy": {
      "name": "Muskelaufbau",
      "description": "4x/Woche Push/Pull/Beine. Bau eine solide Basis auf."
    },
    "intermediate_strength": {
      "name": "Kraftbasis",
      "description": "4x/Woche Ober-/Unterkörper. Schwere Grundübungen für mehr Kraft."
    },
    "intermediate_hypertrophy": {
      "name": "Volumenmaschine",
      "description": "5x/Woche PPL + Ober-/Unterkörper. Hohes Volumen für maximales Wachstum."
    },
    "advanced_strength": {
      "name": "Volle Kraft",
      "description": "5x/Woche Powerlifting-Basis. Fokus auf Kniebeugen, Bankdrücken und Kreuzheben."
    },
    "advanced_performance": {
      "name": "Elite-Athlet",
      "description": "6x/Woche Athletiktraining. Explosivkraft, Hypertrophie und Kondition."
    }
  },
  "PL": {
    "beginner_weight_loss": {
      "name": "Start spalania",
      "description": "3x/tydzień obwód na całe ciało na redukcję. Dużo powtórzeń, krótka przerwa."
    },
    "beginner_hypertrophy": {
      "name": "Budowa mięśni",
      "description": "4x/tydzień pchanie/ciągnięcie/nogi. Zbuduj solidną bazę."
    },
    "intermediate_strength": {
      "name": "Fundament siły",
      "description": "4x/tydzień góra/dół. Ciężkie ćwiczenia złożone na siłę."
    },
    "intermediate_hypertrophy": {
      "name": "Maszyna objętości",
      "description": "5x/tydzień PPL + góra/dół. Duża objętość na maksymalny wzrost."
    },
    "advanced_strength": {
      "name": "Pełna siła",
      "description": "5x/tydzień baza powerliftingu. Skupienie na przysiadzie, wyciskaniu, martwym ciągu."
    },
    "advanced_performance": {
      "name": "Elitarny atleta",
      "description": "6x/tydzień trening atletyczny. Moc, hipertrofia i kondycja."
    }
  },
  "BG": {
    "beginner_weight_loss": {
      "name": "Начално изгаряне",
      "description": "3x/седмица кръгова тренировка за цяло тяло за отслабване. Много повторения, кратка почивка."
    },
    "beginner_hypertrophy": {
      "name": "Мускулен строител",
      "description": "4x/седмица бутане/теглене/крака. Изгради солидна основа."
    },
    "intermediate_strength": {
      "name": "Основа за сила",
      "description": "4x/седмица горна/долна част. Тежки базови движения за сила."
    },
    "intermediate_hypertrophy": {
      "name": "Машина за обем",
      "description": "5x/седмица PPL + горна/долна част. Голям обем за максимален растеж."
    },
    "advanced_strength": {
      "name": "Пълна сила",
      "description": "5x/седмица силова база. Фокус върху клек, лежанка, мъртва тяга."
    },
    "advanced_performance": {
      "name": "Елитен атлет",
      "description": "6x/седмица атлетична тренировка. Мощ, хипертрофия и кондиция."
    }
  }
};
